import { ISbStoryData } from 'storyblok-js-client';

import { AuthorStoryblok, ExpertStoryblok } from '@monoimin/sb-types';
import { getRelationStory } from '@monoimin/storyblok/getRelationStory';

const handleSlug = (slug: string | undefined) => {
  if (!slug) {
    return '';
  }

  return slug.replace(/-/g, ' ');
};

export const getPersonName = async (
  person:
    | string
    | ISbStoryData<AuthorStoryblok>
    | ISbStoryData<ExpertStoryblok>
    | undefined
    | null
): Promise<string> => {
  if (!person) {
    return '';
  }

  if (typeof person === 'string') {
    const res = await getRelationStory<AuthorStoryblok>(person);
    return handleSlug(res?.slug);
  }

  return handleSlug(person.slug);
};
